module.exports = __webpack_public_path__ + "media/assets/images/arrow_right-d215139d17427a7c12bd6c9cf95c5cf2.png";